@if (!!fieldData) {
  <ziro-natural-language-editor
    [entity]="fieldData"
    [dataAutomation]="'unanswered-call-rules-field'"
    (entityUpdate)="updateSelf($event, true, fieldData)"
    (validationUpdate)="updateValidationState($event)"
    [disabled]="disabled()"
    [disabledTooltip]="'tkey;microsoft_360.view.teams.call_forward_settings.unanswered_rules.disabled'"
  >
    <span
      [innerHTML]="'tkey;microsoft_360.view.teams.call_forward_settings.unanswered_rules.form.prefix' | escapeHtml"
    ></span>
    <ziro-natural-language-editor-double
      [options]="unansweredTargetTypeOptions"
      [primaryDropdownLabel]="
        'tkey;microsoft_360.view.teams.call_forward_settings.unanswered_rules.form.target_type.label'
      "
      [phraseId]="'unansweredTarget'"
    ></ziro-natural-language-editor-double>
    <span
      [hidden]="fieldData.unansweredTarget.primary === UnansweredRulesFieldUnansweredTargetType.NONE"
      [innerHTML]="'tkey;microsoft_360.view.teams.call_forward_settings.unanswered_rules.form.conjunction' | escapeHtml"
    ></span>
    <ziro-natural-language-editor-single
      [hidden]="fieldData.unansweredTarget.primary === UnansweredRulesFieldUnansweredTargetType.NONE"
      [options]="unansweredDelayOptions"
      [phraseId]="'unansweredDelay'"
    ></ziro-natural-language-editor-single>
  </ziro-natural-language-editor>
}
